import React from "react";
import {Link} from "react-router-dom";
import {TrainingsData} from "../pages/types";
import {dateFormat} from "../units";

const Item: React.FC<TrainingsData> = (props) => {
    return <Link className="training-item" to={`/home/trainings/${props.id}/detail`}>
        <div className="img-box">
            <div className="bg" style={{backgroundImage: `url(${props.coverUrl})`}}/>
        </div>
        <h3>{props.trainTitle}</h3>
    </Link>
}

const ItemDetail: React.FC<TrainingsData> = (props) => {
    return <Link className="training-item-detail" to={`/home/trainings/${props.id}/detail`}>
        <div className="img-box">
            <div className="bg" style={{backgroundImage: `url(${props.coverUrl})`}}/>
        </div>
        <div className="text">
            <h3>{props.trainTitle}</h3>
            <p className="t">
                {/*<span className='iconfont'>&#xe616;</span>*/}
                活动时间：
                {
                   dateFormat( props.startTime)
                } 至 {
               dateFormat(props.endTime)
            }
            </p>
            <p className="d">{props.threshold}</p>
        </div>
    </Link>
}

interface ActiveList {
    lists: Array<TrainingsData>,
    type?: 'home' | 'detail'
}

const TrainingsList: React.FC<ActiveList> = ({lists, type = 'detail'}) => {
    return <div className="training-list">
        {
            lists.map((item, index) => {
                return <React.Fragment key={index}>
                    {
                        type === 'detail' ? <ItemDetail {...item}/> : <Item {...item}/>
                    }
                </React.Fragment>
            })
        }
    </div>
}

export default TrainingsList;
